import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const ReportSpamIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "ReportSpam",
    children: /*#__PURE__*/_jsx("path", {
      d: "m29.53 9.76-7.29-7.3c-.28-.28-.67-.45-1.09-.45H10.84c-.42 0-.81.18-1.08.45l-7.3 7.3c-.28.28-.45.66-.45 1.08v10.32c0 .42.18.81.45 1.08l7.3 7.3c.28.28.66.45 1.08.45h10.32c.42 0 .81-.18 1.08-.45l7.3-7.3c.28-.28.45-.66.45-1.08V10.84c0-.43-.18-.81-.47-1.08Zm-15.28-.83c.18-.21.45-.34.75-.34h1.99c.55 0 .99.44.99.99 0 .06 0 .12-.02.18s-.99 6.92-.99 6.92c-.08.48-.49.84-.98.84s-.9-.36-.98-.83-.99-6.93-.99-6.93a1 1 0 0 1-.02-.18c0-.25.09-.48.25-.66s0 .01 0 .01m1.74 14.5c-1.1 0-1.98-.89-1.98-1.98s.89-1.98 1.98-1.98 1.98.89 1.98 1.98c0 1.1-.89 1.98-1.98 1.98"
    })
  }));
};